import * as yup from "yup";
import {
  ValidatedData as GetValidatedData,
  ValidColumnKeysBySheet,
} from "utils/xlsxImportExport/XlsxImportWorkBook";
import createDefinitionHelpers from "utils/xlsxImportExport/definitionHelpers";
import isoDateStr from "utils/schemas/isoDateStr";
import { COMMENTS_TITLE } from "components/Comments/utils";

export type CommentRow = {
  postedAt: ISODateTime;
  relatedItemName?: string | null;
  authorName?: string | null;
  authorEmail: string;
  body: string;
};

const customersDef = createDefinitionHelpers<CommentRow>();

export const CUSTOMER_WORKSHEET_DEFINITION = customersDef.workSheet({
  key: "comments",
  sheetName: COMMENTS_TITLE,
  schema: yup.object().shape({
    postedAt: isoDateStr({ isDateTime: true }).required(),
    commentType: yup.string().required(),
    relatedItemName: yup.string().nullable(),
    authorName: yup.string().nullable(),
    authorEmail: yup.string().email().required(),
    body: yup.string().required(),
  }),
  columnDefinitions: [
    { key: "postedAt", header: "Posted At", isRequired: true },
    { key: "relatedItemName", header: "Comment On" },
    { key: "authorName", header: "Author Name" },
    { key: "authorEmail", header: "Author Email", isRequired: true },
    { key: "body", header: "Comment", isRequired: true },
  ],
});

export const WORKSHEET_DEFINITIONS = [CUSTOMER_WORKSHEET_DEFINITION];

export type WorkSheetDefinitions = (typeof WORKSHEET_DEFINITIONS)[number];

export type ValidatedData = GetValidatedData<WorkSheetDefinitions>;

export type ValidColumnKeys = ValidColumnKeysBySheet<WorkSheetDefinitions>;
